<template>
  <v-btn rounded="pill" class="send-homework-btn" @click.stop="openEklaseModal">
    <v-icon class="send-homework-icon" icon="fa-light fa-paper-plane" />
    <span class="send-homework-text d-none d-md-inline">Uzdot E-klasē</span>
  </v-btn>
</template>

<script lang="ts">
import { useEklaseStore } from "~/stores/eklaseStore"

export default {
  setup() {
    const eklaseStore = useEklaseStore()
    return { eklaseStore }
  },

  methods: {
    openEklaseModal() {
      this.eklaseStore.setModalOpen(true)
    },
  },
}
</script>

<style lang="sass">
.send-homework-btn
  text-transform: none
  letter-spacing: 0.1px
  font-weight: 400
  font-size: 16px
  line-height: 20px
  min-width: 0

.send-homework-icon
  margin-right: 12px
</style>
